export default __webpack_public_path__ + "static/works-3-1-900f913e5532c402f459d7d8b5673293.jpg";